import { Dialog } from "radix-ui";
import DefaultButton from "../../atoms/buttons/DefaultButton";
import { useTranslation } from "react-i18next";
import { useDialog } from "../../../hooks/useDialog";

export default function DialogFooter({
  label = "",
  secondaryLabel = "",
  onModalSubmit,
}) {
  const { t } = useTranslation();
  const { hideDialog } = useDialog();

  return (
    <Dialog.Close asChild>
      <div className="flex gap-2">
        <DefaultButton
          className={
            secondaryLabel.length
              ? "bg-white text-vestelColor border border-vestelColor hover:text-white"
              : ""
          }
          label={label || t("dialog.okey")}
          onClick={onModalSubmit}
        />
        {!!secondaryLabel.length && (
          <DefaultButton label={secondaryLabel} onClick={hideDialog} />
        )}
      </div>
    </Dialog.Close>
  );
}
